// Generated by purs version 0.15.0
import * as Affjax from "../Affjax/index.js";
import * as Affjax_RequestBody from "../Affjax.RequestBody/index.js";
import * as Affjax_RequestHeader from "../Affjax.RequestHeader/index.js";
import * as Affjax_ResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax_StatusCode from "../Affjax.StatusCode/index.js";
import * as Affjax_Web from "../Affjax.Web/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HTTP_Method from "../Data.HTTP.Method/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_NonEmpty from "../Data.List.NonEmpty/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_MediaType_Common from "../Data.MediaType.Common/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unfoldable from "../Data.Unfoldable/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic from "../Foreign.Generic/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Foreign_Index from "../Foreign.Index/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var Request = function (x) {
    return x;
};
var MethodNotFound = /* #__PURE__ */ (function () {
    function MethodNotFound(value0) {
        this.value0 = value0;
    };
    MethodNotFound.create = function (value0) {
        return new MethodNotFound(value0);
    };
    return MethodNotFound;
})();
var InvalidParams = /* #__PURE__ */ (function () {
    function InvalidParams(value0) {
        this.value0 = value0;
    };
    InvalidParams.create = function (value0) {
        return new InvalidParams(value0);
    };
    return InvalidParams;
})();
var OtherError = /* #__PURE__ */ (function () {
    function OtherError(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    OtherError.create = function (value0) {
        return function (value1) {
            return new OtherError(value0, value1);
        };
    };
    return OtherError;
})();
var UnexpectedStatus = /* #__PURE__ */ (function () {
    function UnexpectedStatus(value0) {
        this.value0 = value0;
    };
    UnexpectedStatus.create = function (value0) {
        return new UnexpectedStatus(value0);
    };
    return UnexpectedStatus;
})();
var NetworkError = /* #__PURE__ */ (function () {
    function NetworkError(value0) {
        this.value0 = value0;
    };
    NetworkError.create = function (value0) {
        return new NetworkError(value0);
    };
    return NetworkError;
})();
var DecodingError = /* #__PURE__ */ (function () {
    function DecodingError(value0) {
        this.value0 = value0;
    };
    DecodingError.create = function (value0) {
        return new DecodingError(value0);
    };
    return DecodingError;
})();
var RPCError = /* #__PURE__ */ (function () {
    function RPCError(value0) {
        this.value0 = value0;
    };
    RPCError.create = function (value0) {
        return new RPCError(value0);
    };
    return RPCError;
})();
var Success = /* #__PURE__ */ (function () {
    function Success(value0) {
        this.value0 = value0;
    };
    Success.create = function (value0) {
        return new Success(value0);
    };
    return Success;
})();
var RPCFailure = /* #__PURE__ */ (function () {
    function RPCFailure(value0) {
        this.value0 = value0;
    };
    RPCFailure.create = function (value0) {
        return new RPCFailure(value0);
    };
    return RPCFailure;
})();
var showRpcError = {
    show: function (v) {
        if (v instanceof MethodNotFound) {
            return "RPC Error: method not found. " + v.value0;
        };
        if (v instanceof InvalidParams) {
            return "RPC Error: invalid params sent to the server. " + v.value0;
        };
        if (v instanceof OtherError) {
            return "RPC Error " + (Data_Show.show(Data_Show.showInt)(v.value0) + (": " + v.value1));
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 33, column 1 - line 36, column 72): " + [ v.constructor.name ]);
    }
};
var rpcMethodName = function (dict) {
    return dict.rpcMethodName;
};
var rpc$prime = function (dictRPCMethodName) {
    return function (dictMonad) {
        return function (run) {
            return function (req) {
                var req$prime = {
                    id: "1",
                    method: rpcMethodName(dictRPCMethodName)(Type_Proxy["Proxy"].value),
                    params: req
                };
                return Control_Bind.bind(dictMonad.Bind1())(run(req$prime))(function (res) {
                    return Control_Applicative.pure(dictMonad.Applicative0())((function () {
                        if (res instanceof Data_Either.Right && res.value0 instanceof Success) {
                            return new Data_Either.Right(res.value0.value0.result);
                        };
                        if (res instanceof Data_Either.Right && res.value0 instanceof RPCFailure) {
                            return new Data_Either.Left(new RPCError(res.value0.value0.error));
                        };
                        if (res instanceof Data_Either.Left) {
                            return new Data_Either.Left(res.value0);
                        };
                        throw new Error("Failed pattern match at Network.JsonRPC (line 122, column 10 - line 125, column 29): " + [ res.constructor.name ]);
                    })());
                });
            };
        };
    };
};
var remoteErrorToString = function (v) {
    if (v instanceof UnexpectedStatus) {
        return "UnexpectedStatus: " + Data_Show.show(Affjax_StatusCode.showStatusCode)(v.value0);
    };
    if (v instanceof NetworkError) {
        return "NetworkError: " + v.value0;
    };
    if (v instanceof DecodingError) {
        return "DecodingError: " + v.value0;
    };
    if (v instanceof RPCError) {
        return "RPCError: " + Data_Show.show(showRpcError)(v.value0);
    };
    throw new Error("Failed pattern match at Network.JsonRPC (line 112, column 3 - line 116, column 45): " + [ v.constructor.name ]);
};
var rpc = function (dictRPCMethodName) {
    return function (dictMonad) {
        return function (run) {
            var $116 = Data_Functor.map(((dictMonad.Bind1()).Apply0()).Functor0())(Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)(remoteErrorToString));
            var $117 = rpc$prime(dictRPCMethodName)(dictMonad)(run);
            return function ($118) {
                return $116($117($118));
            };
        };
    };
};
var newtypeRequest = {
    Coercible0: function () {
        return undefined;
    }
};
var genericResponse = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Success(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new RPCFailure(x.value0);
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 54, column 1 - line 54, column 58): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Success) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof RPCFailure) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 54, column 1 - line 54, column 58): " + [ x.constructor.name ]);
    }
};
var genericRequest = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericRemoteError = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new UnexpectedStatus(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new NetworkError(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new DecodingError(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new RPCError(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 99, column 1 - line 99, column 60): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof UnexpectedStatus) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof NetworkError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof DecodingError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof RPCError) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 99, column 1 - line 99, column 60): " + [ x.constructor.name ]);
    }
};
var showRemoteError = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericRemoteError)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Affjax_StatusCode.showStatusCode))({
        reflectSymbol: function () {
            return "UnexpectedStatus";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "NetworkError";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "DecodingError";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showRpcError))({
        reflectSymbol: function () {
            return "RPCError";
        }
    })))))
};
var errorUnexpectedStatus = /* #__PURE__ */ (function () {
    return UnexpectedStatus.create;
})();
var eqRPCError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof MethodNotFound && y instanceof MethodNotFound) {
                return x.value0 === y.value0;
            };
            if (x instanceof InvalidParams && y instanceof InvalidParams) {
                return x.value0 === y.value0;
            };
            if (x instanceof OtherError && y instanceof OtherError) {
                return x.value0 === y.value0 && x.value1 === y.value1;
            };
            return false;
        };
    }
};
var eqRemoteError = {
    eq: function (x) {
        return function (y) {
            if (x instanceof UnexpectedStatus && y instanceof UnexpectedStatus) {
                return Data_Eq.eq(Affjax_StatusCode.eqStatusCode)(x.value0)(y.value0);
            };
            if (x instanceof NetworkError && y instanceof NetworkError) {
                return x.value0 === y.value0;
            };
            if (x instanceof DecodingError && y instanceof DecodingError) {
                return x.value0 === y.value0;
            };
            if (x instanceof RPCError && y instanceof RPCError) {
                return Data_Eq.eq(eqRPCError)(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var encodeRequest = function (dictEncode) {
    return function (dictEncodeWithOptions) {
        return {
            encode: Foreign_Encoding.defaultEncode(genericRequest)(Foreign_Generic_Class.genericEncodeConstructor({
                reflectSymbol: function () {
                    return "Request";
                }
            })(Foreign_Generic_Class.genericEncodeArgsRecord(Foreign_Generic_Class.encodeWithOptionsRecord()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
                reflectSymbol: function () {
                    return "params";
                }
            })(dictEncodeWithOptions))({
                reflectSymbol: function () {
                    return "method";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
                reflectSymbol: function () {
                    return "id";
                }
            })(Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
        };
    };
};
var decodeRPCError = {
    decode: function (value) {
        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(Foreign_Index.indexString(Data_Identity.monadIdentity))(value)("code"))(Foreign.readInt(Data_Identity.monadIdentity)))(function (code) {
            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(Foreign_Index.indexString(Data_Identity.monadIdentity))(value)("message"))(Foreign.readString(Data_Identity.monadIdentity)))(function (message) {
                return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))((function () {
                    if (code === -32601) {
                        return new MethodNotFound(message);
                    };
                    if (code === -32602) {
                        return new InvalidParams(message);
                    };
                    return new OtherError(code, message);
                })());
            });
        });
    }
};
var decodeResponse = function (dictDecode) {
    return {
        decode: function (value) {
            return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(Foreign_Index.indexString(Data_Identity.monadIdentity))(value)("id"))(Foreign.readString(Data_Identity.monadIdentity)))(function (id) {
                return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(Foreign_Index.indexString(Data_Identity.monadIdentity))(value)("error"))(Foreign.readNullOrUndefined(Data_Identity.monadIdentity)))(Data_Traversable.traverse(Data_Traversable.traversableMaybe)(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(Foreign_Generic_Class.decode(decodeRPCError))))(function (mError) {
                    if (mError instanceof Data_Maybe.Just) {
                        return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new RPCFailure({
                            id: id,
                            error: mError.value0
                        }));
                    };
                    if (mError instanceof Data_Maybe.Nothing) {
                        return Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity))(Foreign_Index.ix(Foreign_Index.indexableForeign(Data_Identity.monadIdentity))(Foreign_Index.indexString(Data_Identity.monadIdentity))(value)("result"))(Foreign_Generic_Class.decode(dictDecode)))(function (result) {
                            return Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity))(new Success({
                                id: id,
                                result: result
                            }));
                        });
                    };
                    throw new Error("Failed pattern match at Network.JsonRPC (line 63, column 5 - line 67, column 50): " + [ mError.constructor.name ]);
                });
            });
        }
    };
};
var decodeJSON$prime = function (dictDecode) {
    return function (json) {
        var v = Control_Monad_Except.runExcept(Foreign_Generic.decodeJSON(dictDecode)(json));
        if (v instanceof Data_Either.Right) {
            return new Data_Either.Right(v.value0);
        };
        if (v instanceof Data_Either.Left) {
            return new Data_Either.Left(new DecodingError(Data_String_Common.joinWith("\x0a")(Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(Foreign.showForeignError))(Data_List.toUnfoldable(Data_Unfoldable.unfoldableArray)(Data_List_NonEmpty.toList(v.value0))))));
        };
        throw new Error("Failed pattern match at Network.JsonRPC (line 168, column 3 - line 170, column 110): " + [ v.constructor.name ]);
    };
};
var runAffjax = function (dictEncode) {
    return function (dictDecode) {
        return function (api) {
            return function (authHeaders) {
                return function (request) {
                    var request$prime = {
                        method: new Data_Either.Left(Data_HTTP_Method.POST.value),
                        url: api,
                        headers: Data_Semigroup.append(Data_Semigroup.semigroupArray)(authHeaders)([ new Affjax_RequestHeader.ContentType(Data_MediaType_Common.applicationJSON) ]),
                        content: new Data_Maybe.Just(new Affjax_RequestBody["String"](Foreign_Generic.encodeJSON(dictEncode)(request))),
                        username: Affjax.defaultRequest.username,
                        password: Affjax.defaultRequest.password,
                        withCredentials: Affjax.defaultRequest.withCredentials,
                        responseFormat: Affjax_ResponseFormat.string,
                        timeout: Affjax.defaultRequest.timeout
                    };
                    var handleResponse = function (v) {
                        if (v instanceof Data_Either.Left) {
                            return new Data_Either.Left(new NetworkError(Affjax.printError(v.value0)));
                        };
                        if (v instanceof Data_Either.Right) {
                            if (Data_Eq.eq(Affjax_StatusCode.eqStatusCode)(v.value0.status)(200)) {
                                return decodeJSON$prime(dictDecode)(v.value0.body);
                            };
                            if (Data_Boolean.otherwise) {
                                return new Data_Either.Left(errorUnexpectedStatus(v.value0.status));
                            };
                        };
                        throw new Error("Failed pattern match at Network.JsonRPC (line 151, column 3 - line 151, column 74): " + [ v.constructor.name ]);
                    };
                    return Data_Functor.map(Effect_Aff.functorAff)(handleResponse)(Affjax_Web.request(request$prime));
                };
            };
        };
    };
};
export {
    rpcMethodName,
    MethodNotFound,
    InvalidParams,
    OtherError,
    Request,
    Success,
    RPCFailure,
    UnexpectedStatus,
    NetworkError,
    DecodingError,
    RPCError,
    rpc,
    remoteErrorToString,
    rpc$prime,
    errorUnexpectedStatus,
    runAffjax,
    decodeJSON$prime,
    showRpcError,
    eqRPCError,
    newtypeRequest,
    genericRequest,
    genericResponse,
    encodeRequest,
    decodeResponse,
    decodeRPCError,
    genericRemoteError,
    eqRemoteError,
    showRemoteError
};
//# sourceMappingURL=index.js.map
